export default "__VITE_ASSET__C9DI5SpG__"